module.exports = __webpack_public_path__ + "img/mob_about_03.49d702b9.png";